// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".build-status .content[data-v-75705bbf]{height:100%;display:grid;grid-template-columns:repeat(3,1fr);grid-gap:16px}.build-status .info-block.emphasize .value[data-v-75705bbf]{font-weight:700}.build-status .info-block.emphasize.errors .value[data-v-75705bbf]{color:#e83030!important}.build-status .info-block.emphasize.warnings .value[data-v-75705bbf]{color:#ea6e00!important}", ""]);
// Exports
module.exports = exports;
